import React from 'react';

import { IconProps } from '../DefaultIcon';

export function ImagemInstIcon({ className }: IconProps) {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2_831)">
        <path
          d="M70.7879 80V3.62538C70.7879 1.69184 69.0909 0 67.1515 0H3.63636C1.69697 0 0 1.69184 0 3.62538V70.0906C0 75.4079 4.36364 79.7583 9.69697 79.7583H70.7879V80Z"
          fill="#EAEEF9"
        />
        <path
          d="M8.24243 34.3202H4.84849C4.36364 34.3202 4.12122 34.5619 4.12122 35.0453V43.0211C4.12122 43.2628 4.36364 43.5045 4.84849 43.5045H8.24243C8.72728 43.5045 8.9697 43.2628 8.9697 42.7795V34.8036C8.9697 34.5619 8.48485 34.3202 8.24243 34.3202Z"
          fill="white"
        />
        <path
          d="M15.0303 28.5196H11.8788C11.3939 28.5196 11.1515 28.7613 11.1515 29.2447V43.0211C11.1515 43.5045 11.3939 43.7462 11.8788 43.7462H15.2727C15.7576 43.7462 16 43.5045 16 43.0211V29.2447C15.7575 28.7613 15.5151 28.5196 15.0303 28.5196Z"
          fill="white"
        />
        <path
          d="M22.0607 19.3354H18.6667C18.1819 19.3354 17.9395 19.8187 17.9395 20.0604V42.7795C17.9395 43.2628 18.1819 43.5045 18.6667 43.5045H22.0607C22.5455 43.5045 22.7879 43.2628 22.7879 42.7795V20.0604C22.7879 19.8187 22.3031 19.3354 22.0607 19.3354Z"
          fill="white"
        />
        <path
          d="M28.8485 23.4441H25.4546C24.9697 23.4441 24.7273 23.6858 24.7273 24.1692V43.0211C24.7273 43.5045 24.9697 43.7462 25.4546 43.7462H28.8485C29.3334 43.7462 29.5758 43.5045 29.5758 43.0211V24.1692C29.5758 23.6858 29.3334 23.4441 28.8485 23.4441Z"
          fill="white"
        />
        <path
          d="M35.8788 15.2266H32.4848C32 15.2266 31.7576 15.4683 31.7576 15.9517V42.7795C31.7576 43.2628 32 43.5045 32.4848 43.5045H35.8788C36.3636 43.5045 36.6061 43.2628 36.6061 42.7795V15.9517C36.6061 15.4683 36.1212 15.2266 35.8788 15.2266Z"
          fill="white"
        />
        <path
          d="M41.6969 51.2387H31.2727C30.7878 51.2387 30.0605 50.7553 30.0605 50.0302C30.0605 49.3051 30.5454 48.8217 31.2727 48.8217H41.6969C42.1818 48.8217 42.909 49.3051 42.909 50.0302C42.909 50.7553 42.4242 51.2387 41.6969 51.2387Z"
          fill="white"
        />
        <path
          d="M25.6969 51.2387H23.2727C22.7878 51.2387 22.0605 50.7553 22.0605 50.0302C22.0605 49.3051 22.5454 48.8217 23.2727 48.8217H25.6969C26.1818 48.8217 26.909 49.3051 26.909 50.0302C26.909 50.7553 26.4242 51.2387 25.6969 51.2387Z"
          fill="white"
        />
        <path
          d="M41.6969 58.4894H31.2727C30.7878 58.4894 30.0605 58.006 30.0605 57.281C30.0605 56.5559 30.5454 56.0725 31.2727 56.0725H41.6969C42.1818 56.0725 42.909 56.5559 42.909 57.281C42.909 58.006 42.4242 58.4894 41.6969 58.4894Z"
          fill="white"
        />
        <path
          d="M25.6969 58.4894H23.2727C22.7878 58.4894 22.0605 58.006 22.0605 57.281C22.0605 56.5559 22.5454 56.0725 23.2727 56.0725H25.6969C26.1818 56.0725 26.909 56.5559 26.909 57.281C26.909 58.006 26.4242 58.4894 25.6969 58.4894Z"
          fill="white"
        />
        <path
          d="M62.5454 65.7402H31.2727C30.7878 65.7402 30.0605 65.2568 30.0605 64.5317C30.0605 63.8067 30.5454 63.3233 31.2727 63.3233H62.5454C63.0302 63.3233 63.7575 63.8067 63.7575 64.5317C63.7575 65.2568 63.2727 65.7402 62.5454 65.7402Z"
          fill="white"
        />
        <path
          d="M25.6969 65.7402H23.2727C22.7878 65.7402 22.0605 65.2568 22.0605 64.5317C22.0605 63.8067 22.5454 63.3233 23.2727 63.3233H25.6969C26.1818 63.3233 26.909 63.8067 26.909 64.5317C26.909 65.2568 26.4242 65.7402 25.6969 65.7402Z"
          fill="white"
        />
        <path
          d="M52.8484 72.9909H31.2727C30.7878 72.9909 30.0605 72.5076 30.0605 71.7825C30.0605 71.0574 30.5454 70.574 31.2727 70.574H52.8484C53.3333 70.574 54.0605 71.0574 54.0605 71.7825C54.0605 72.5076 53.3333 72.9909 52.8484 72.9909Z"
          fill="#B0B9CF"
        />
        <path
          d="M25.6969 72.9909H23.2727C22.7878 72.9909 22.0605 72.5076 22.0605 71.7825C22.0605 71.0574 22.5454 70.574 23.2727 70.574H25.6969C26.1818 70.574 26.909 71.0574 26.909 71.7825C26.909 72.5076 26.4242 72.9909 25.6969 72.9909Z"
          fill="#B0B9CF"
        />
        <path
          d="M9.93945 80C14.5455 80 18.4243 76.6163 19.1516 72.0242C19.1516 71.2991 19.8788 70.8157 20.6061 70.8157H78.5455C79.5152 70.8157 80.2425 71.5408 80.0001 72.5075C79.2728 76.858 75.394 80 70.7879 80H9.93945Z"
          fill="#00C4B3"
        />
        <path
          d="M67.8788 29.9698C67.8788 26.3444 66.4243 22.9607 64 20.5438C61.3334 17.8852 57.9394 16.6767 54.3031 16.6767C50.6667 16.6767 47.2728 18.1269 44.6061 20.5438C41.9394 23.2024 40.7273 26.5861 40.7273 30.2115C40.7273 33.8369 42.1818 37.2206 44.6061 39.8792C47.0303 42.2961 50.4243 43.7462 54.0606 43.7462H54.3031C57.9394 43.7462 61.3334 42.2961 64 39.8792L64.4849 39.3958L62.3031 37.2206L61.8182 37.7039C59.8788 39.6375 57.2121 40.8459 54.3031 40.8459C51.394 40.8459 48.7273 39.6375 46.7879 37.7039C44.8485 35.7704 43.6364 33.1118 43.6364 30.2115C43.6364 27.3112 44.8485 24.6526 46.7879 22.719C48.7273 20.7855 51.394 19.577 54.3031 19.577C57.2121 19.577 59.8788 20.7855 61.8182 22.719C63.5152 24.4109 64.4849 26.5861 64.7273 28.7613H62.5455H62.3031C62.0606 27.0695 61.0909 25.6193 59.8788 24.1692C58.1818 22.4773 56.2425 21.7523 53.8182 21.7523C51.394 21.7523 49.4546 22.719 47.7576 24.1692C46.0606 25.861 45.3334 27.7946 45.3334 30.2115C45.3334 32.3867 46.3031 34.5619 47.7576 36.2538C49.2121 37.7039 51.394 38.6707 53.5758 38.6707H53.8182C56 38.6707 58.1818 37.7039 59.8788 36.2538L60.3637 35.7704L58.1818 33.5952V34.0786C57.2121 35.0453 55.7576 35.7704 54.3031 35.7704C52.8485 35.7704 51.394 35.287 50.4243 34.0786C49.697 33.3535 49.2121 32.6284 48.9697 31.6616H52.8485H54.3031H59.8788H62.7879H67.8788V29.9698ZM54.3031 28.7613H52.8485H48.9697C49.2121 27.7946 49.697 27.0695 50.4243 26.3444C51.394 25.3776 52.8485 24.6526 54.3031 24.6526C55.7576 24.6526 57.2121 25.136 58.1818 26.3444C58.9091 27.0695 59.394 27.7946 59.6364 28.7613H54.3031Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_831">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
